import {
  getCurrentUser,
  useSession,
} from "./session";

/*
 * One source of truth for signed-in state.
 *
 * session.js owns the GoOurHub session under:
 *   localStorage["gohubSession"]
 *
 * Header, profile, favorites, and Add Business should all
 * read the same session instead of independently guessing
 * which localStorage key represents the signed-in user.
 */

const buildIdentity = (user) => {
  if (!user?.email) {
    return null;
  }

  const email = String(user.email)
    .trim()
    .toLowerCase();

  const firstName = String(
    user.firstName || ""
  ).trim();

  const displayName =
    firstName ||
    (email ? email.split("@")[0] : "");

  return {
    raw: user,
    email,
    name: displayName,
  };
};

/*
 * Keep this export because other existing files may already
 * import readAuthUser().
 */
export const readAuthUser = () => {
  return buildIdentity(getCurrentUser());
};

/*
 * Keep this export for compatibility with older login code.
 *
 * The real session event used by session.js is "gohub-session".
 */
export const announceAuthChange = () => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new Event("gohub-session")
  );

  // Keep the older event too in case another existing
  // component still listens for it.
  window.dispatchEvent(
    new Event("goh:auth-changed")
  );
};

export function useAuthUser() {
  const session = useSession();

  const identity = buildIdentity(session);

  return {
    user: identity?.raw || null,
    isSignedIn: Boolean(identity),
    displayName: identity?.name || "",
    email: identity?.email || "",
  };
}